<div class="wrapper">
  <div class="background">
    <canvas #scheduleEl 
    class="schedule-canvas"></canvas>
    <div class="daynum">{{day.day}}</div>
    <div class=dayofwk>{{day.wkday}}</div>
    <!-- <button onClick="handleClick()">Add Event</button> -->
  </div>
</div>